export default "__VITE_ASSET__DdANk0Mr__"